import { Box } from "@mui/material";
import { useTranslation } from "next-i18next";
import { IKeyFigureGroup, ITags } from "src/api/server/extended-search.types";
import { NUMBER_OF_LEVERAGE_PRODUCT_OPTIONS } from "src/components/pages/search/constants";
import { usePopularFiltersCounter } from "src/components/pages/search/hooks/use-popular-filters-counter";
import { handleResetPopularFilters } from "src/components/pages/search/store/actions";
import { Button } from "src/components-mui/base/button/button";
import { PopperWrapper } from "../popover/popper-wrapper";
import { PopularFiltersContent } from "./components/popular-filters-content";

const POPULAR_FILTERS_POPOVER_BODY_TEST_ID = "popular-filters-popover-body";

interface IPopularFiltersPopover {
    popularKeyFiguresGroup: IKeyFigureGroup;
    tagsData: ITags;
}

export const PopularFiltersPopover = ({ popularKeyFiguresGroup, tagsData }: IPopularFiltersPopover) => {
    const { t } = useTranslation("extended-search");

    const numberOfSelectedFilters = usePopularFiltersCounter();

    const { basics, rewards, tradings, investmentHorizon, investmentRegion, alphaBeta } = tagsData;
    const numberOfPopularFilters =
        popularKeyFiguresGroup.keyFigures.length +
        basics.tags.length +
        tradings.tags.length +
        rewards.tags.length +
        investmentHorizon.tags.length +
        investmentRegion.tags.length +
        alphaBeta.tags.length +
        NUMBER_OF_LEVERAGE_PRODUCT_OPTIONS;

    const handleReset = () => {
        handleResetPopularFilters();
    };

    return (
        <PopperWrapper
            placement="bottom-start"
            bodyTestId={POPULAR_FILTERS_POPOVER_BODY_TEST_ID}
            id={t("labels.popular-filters")}
            buttonProps={{
                title: t("labels.popular-filters"),
                badgeInfo: `${numberOfSelectedFilters} / ${numberOfPopularFilters}`,
            }}
            popperSx={{
                zIndex: 1,
                width: { xs: "100%", sm: "100%", md: "810px" },
                px: { xs: 1, sm: 1, md: 0 },
            }}
            boxSx={{
                p: 3,
            }}
        >
            <PopularFiltersContent popularKeyFiguresGroup={popularKeyFiguresGroup} tagsData={tagsData} />
            <Box>
                <Button variant="ghost-underline" size="small" sx={{ ml: -2 }} onClick={handleReset}>
                    {t("buttons.reset-popular-filters")}
                </Button>
            </Box>
        </PopperWrapper>
    );
};
